import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=8988f194&scoped=true&"
import script from "./Cases.vue?vue&type=script&lang=ts&"
export * from "./Cases.vue?vue&type=script&lang=ts&"
import style0 from "./Cases.vue?vue&type=style&index=0&id=8988f194&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8988f194",
  null
  
)

export default component.exports